import { Pipe, PipeTransform } from '@angular/core';
import { getRangeDate } from '../utils';


@Pipe({
    name: 'rangeDate',
    standalone: false
})
export class RangeDatePipe implements PipeTransform {
  transform(startDate: Date, range: number): Date {
    return getRangeDate(startDate, range);
  }
}
